export default __webpack_public_path__ + "static/media/google-setup-2-en.db40bc65.jpeg";